import { render, staticRenderFns } from "./FoodTruckDialog.vue?vue&type=template&id=6fe0bc8c&scoped=true&"
import script from "./FoodTruckDialog.vue?vue&type=script&lang=js&"
export * from "./FoodTruckDialog.vue?vue&type=script&lang=js&"
import style0 from "./FoodTruckDialog.vue?vue&type=style&index=0&id=6fe0bc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0bc8c",
  null
  
)

/* custom blocks */
import block0 from "./FoodTruckDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports